export default __webpack_public_path__ + "static/media/info-tooltip.7aa4b2a3.svg";